export default __webpack_public_path__ + "static/media/banner_sell.905860f6.svg";